
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a1 1 0 001 1h5.83a.16.16 0 01.17.17V15a1 1 0 002 0V9.17A.16.16 0 019.17 9H15a1 1 0 000-2H9.17A.16.16 0 019 6.83V1a1 1 0 00-2 0v5.83a.16.16 0 01-.17.17H1a1 1 0 00-1 1z","fill":"currentColor"}})])
          )
        }
      }
    